import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FileText } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-extrabold text-slate-900 mb-2">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-2 text-[15px]">{children}</div>
  </div>
);

export default function LegalNotice() {
  return (
    <div className="App min-h-screen bg-white" data-testid="legal-page">
      <Header />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] mb-3">
          <FileText className="w-4 h-4" /> Informations légales
        </div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tighter font-extrabold text-slate-900">
          Mentions légales
        </h1>

        <div className="mt-10">
          <Section title="Éditeur du site">
            <p>
              Le site <b>lesyeuxdanslimmo.fr</b> est édité par <b>Les Yeux Dans L'Immo</b>.<br />
              Contact : <a href="mailto:lesyeuxdanslimmo@gmail.com" className="text-[#2563EB] underline">lesyeuxdanslimmo@gmail.com</a>
            </p>
            <p className="text-sm text-slate-400">
              (Raison sociale, statut juridique, adresse du siège, n° SIRET et n° de TVA intracommunautaire
              à compléter par l'éditeur.)
            </p>
          </Section>

          <Section title="Directeur de la publication">
            <p>Le représentant légal de Les Yeux Dans L'Immo.</p>
          </Section>

          <Section title="Hébergement">
            <p>
              Le site est hébergé par un prestataire d'hébergement cloud. Les coordonnées complètes de
              l'hébergeur peuvent être obtenues sur simple demande.
            </p>
          </Section>

          <Section title="Propriété intellectuelle">
            <p>
              L'ensemble des contenus (textes, logo, visuels, articles) présents sur ce site sont la propriété
              de Les Yeux Dans L'Immo, sauf mention contraire. Toute reproduction sans autorisation est interdite.
            </p>
          </Section>

          <Section title="Avis de valeur">
            <p>
              Les estimations et avis de valeur fournis par ce site sont donnés à titre purement indicatif et
              ne constituent pas une expertise immobilière réglementée. Ils comportent une marge d'erreur.
            </p>
          </Section>

          <Section title="Données personnelles">
            <p>
              Le traitement de vos données personnelles est décrit dans notre{" "}
              <a href="/confidentialite" className="text-[#2563EB] underline">politique de confidentialité</a>.
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
